// 企业微信登录工具函数
export class WeChatLogin {
  private corpId: string
  private agentId: string

  constructor() {
    this.corpId = import.meta.env.VITE_WECHAT_CORP_ID || ''
    this.agentId = import.meta.env.VITE_WECHAT_AGENT_ID || ''
  }

  // 获取头像URL（后端已返回签名URL，直接使用）
  getAvatarUrl(avatarUrl?: string): string | undefined {
    if (!avatarUrl) {
      console.log('🔍 getAvatarUrl: 没有头像URL')
      return undefined
    }
    
    console.log('🔍 getAvatarUrl: 头像URL:', avatarUrl)
    
    // 后端已经返回签名URL，直接使用
    return avatarUrl
  }

  // 生成企业微信登录URL
  generateLoginUrl(redirectUri: string, state: string = 'STATE'): string {
    const baseUrl = 'https://open.weixin.qq.com/connect/oauth2/authorize'
    const params = new URLSearchParams({
      appid: this.corpId,
      redirect_uri: encodeURIComponent(redirectUri),
      response_type: 'code',
      scope: 'snsapi_privateinfo',
      agentid: this.agentId,
      state: state
    })
    
    return `${baseUrl}?${params.toString()}#wechat_redirect`
  }

  // 从URL中提取授权码
  extractCodeFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('code')
  }

  // 从URL中提取state参数
  extractStateFromUrl(): string | null {
    const urlParams = new URLSearchParams(window.location.search)
    return urlParams.get('state')
  }

  // 检查是否在企业微信环境中
  isInWeChatWork(): boolean {
    return /wxwork/i.test(navigator.userAgent)
  }

  // 获取当前页面的完整URL（用于回调）
  getCurrentUrl(): string {
    return window.location.origin + window.location.pathname
  }

  // 跳转到企业微信登录
  redirectToLogin(redirectUri?: string): void {
    const callbackUrl = redirectUri || this.getCurrentUrl()
    const loginUrl = this.generateLoginUrl(callbackUrl)
    console.log('🚀 企业微信登录配置:')
    console.log('  CorpID:', this.corpId)
    console.log('  AgentID:', this.agentId)
    console.log('  回调URL:', callbackUrl)
    console.log('  登录URL:', loginUrl)
    console.log('  是否在企业微信环境:', this.isInWeChatWork())
    window.location.href = loginUrl
  }
}

// 创建单例实例
export const wechatLogin = new WeChatLogin()
